import { Outlet } from "react-router-dom";
import { SettingsOverview } from "@/pages/settings-overview";

export function SettingsLayout() {
  return <Outlet />;
}

export function SettingsIndex() {
  return <SettingsOverview />;
}
